import stickybits from './stickybits'
import Subnav from './subnav'

export default class StickyBar {
  constructor(el) {
    this._stickyBits = stickybits(el)
    this._subnav = new Subnav(el)
  }

  static initialize() {
    const el = document.querySelector('.wz-sticky-bar')
    if (el != null) new StickyBar(el)
  }
}
